import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';

import { getResponse, toastApiError } from '../common';
import { API_URLS } from '../query.client';

export type SendPasswordResetEmailType = { message: string };

async function sendPasswordResetEmail(id: string): Promise<SendPasswordResetEmailType | null> {
	const response = await axios.post(`${API_URLS.USERS.SEND_PASSWORD_RESET_EMAIL(id)}`);
	return getResponse<SendPasswordResetEmailType>(response.data);
}

export function sendPasswordResetEmailOptions() {
	return mutationOptions({
		mutationFn: ({ id }: { id: string }) => sendPasswordResetEmail(id),
		onSuccess: async (data) => {
			console.log('Password reset email sent successfully:', data);
			toast.success(t('admin.toast.passwordResetEmailSent'));
		},
		onError: (error) => toastApiError(error),
	});
}
